export default __webpack_public_path__ + "media/integrations/slack-8e623f80.svg";